import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TableModule } from 'primeng/table'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { InputTextModule } from 'primeng/inputtext'
import { MultiSelectModule } from 'primeng/multiselect'
import { FormsModule } from '@angular/forms'
import { Router } from '@angular/router'

@Component({
  selector: 'app-recommended-prices-quotes-table',
  template: `
    <div class="card">
      <div class="card-body">
        <div class="table-header-container" style="padding-bottom: 1rem">
          <div>
            <span class="text-small-roman"> Results for Quote: </span>
            <span class="text-small-roman" style="font-weight: bold">{{
              quoteId
            }}</span>
          </div>
          <p-multiSelect
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="header"
            selectedItemsLabel="{0} columns selected"
            [style]="{ 'min-width': '200px' }"
            placeholder="Choose Columns"></p-multiSelect>
          <div style="display: flex; gap: 1.5rem;">
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Reset sorting"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.13843 6.75101L8.19576 5.80768L11.3338 2.66968L14.4718 5.80768L13.5291 6.75101L12.0004 5.22234V12.667H10.6671V5.22234L9.13843 6.75101Z"
                    fill="#8A00E5" />
                  <path
                    d="M3.99996 10.7779V3.33328H5.33396V10.7779L6.86196 9.24928L7.8053 10.1919L4.6673 13.3299L1.5293 10.1919L2.47196 9.24928L3.99996 10.7779Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Reset filtering"
              (click)="recQuotesPricesTable.reset()"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.31998 9.33333L1.33398 2H14.6673L8.66732 9.33333V14H7.33398V9.33333H7.31998ZM11.854 3.33333H4.14398L7.95332 8H8.03598L11.854 3.33333Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Download csv"
              (click)="exportCsv(recQuotesPricesTable)"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5727 6.15333L12.426 7.18L7.99935 10.8667L3.57268 7.18L4.42602 6.15333L7.33268 8.58V2H8.66602V8.58L11.5727 6.15333Z"
                    fill="#8A00E5" />
                  <path
                    d="M13.3327 14V12.6667H2.66602V14H13.3327Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
          </div>
        </div>
        <p-table
          #recQuotesPricesTable
          [columns]="selectedColumns"
          [resizableColumns]="true"
          columnResizeMode="expand"
          [value]="data"
          [tableStyle]="{ 'min-width': '50rem' }"
          [paginator]="true"
          [rows]="50"
          [scrollable]="true"
          styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
          sortMode="multiple"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[50, 100, 150, { showAll: 'All' }]"
          [scrollable]="true"
          scrollHeight="53vh">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                class="table-header text-small-strong"
                *ngFor="let col of columns"
                pSortableColumn="{{ col.field }}" pResizableColumn>
                <div style="display: flex; align-items: center">
                  {{ col.header }}
                  <p-sortIcon
                    [field]="col.field"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                    class="mr-auto"></p-sortIcon>

                  <p-columnFilter
                    type="text"
                    display="menu"
                    style="margin-left: 1rem"
                    [field]="col.field"></p-columnFilter>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr class="text-small-roman">
              <td
                *ngFor="let col of cols"
                [ngStyle]="{
                  'text-align': col.align === 'right' ? 'right' : 'left'
                }">
                <div class="td-content">
                  @if (col.field === 'ORIGINAL_REC_PRICE' || col.field ===
                  'ORIGINAL_TA_PRICE__C' || col.field === 'TA_PRICE__C' ||
                  col.field === 'SBQQ__NETPRICE__C' || col.field ===
                  'EDAA_PRICE' || col.field === 'EDAA_PRICE_PERCENT'|| col.field
                  === 'REC_PRICE_CAPPED_PERCENT'|| col.field ===
                  'REC_PRICE_CAPPED' || col.field ==='LAST_QUOTE_PRICE') {
                  {{ rowData[col.field] | number : '1.2-2' }}
                  } @else if (col.field === 'NETPR_EUR' || col.field ===
                  'NETWR_EUR') {
                  {{
                    rowData[col.field]
                      ? (
                          rowData[col.field]
                          | currency : 'EUR' : 'symbol-narrow' : '1.2-2'
                        )?.replace('€', '') + ' €'
                      : ''
                  }}
                  } @else if (col.field === 'SBQQ__DESCRIPTION__C') {
                  <span class="truncate">
                    {{ rowData[col.field] }}
                  </span>
                  } @else if (col.field === 'LAST_QUOTE_DATE') {
                  {{ rowData[col.field] | date : 'mediumDate' }}
                  } @else if (col.field === 'PART_NAME__C'){
                  <span>
                    {{ rowData[col.field] }}
                  </span>
                  @if( rowData[col.field] ){
                  <p-button
                    icon="pi pi-search"
                    class="material-search-btn secondary-btn"
                    size="small"
                    (onClick)="goToRecommendendPrices(rowData[col.field])" />
                  } } @else {
                  {{ rowData[col.field] }}
                  }
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td style="border: none;" colspan="5">
                No results for your search terms.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  `,
  styles: [
    `
      .table-header {
        background-color: #cf9bff40;
        padding: 0.5rem 0.75rem;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        white-space: nowrap;
      }

      .truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 200px;
      }

      .text-small-strong {
        color: #8a00e5 !important;
      }

      td {
        border-right: 1px solid #969696;
        text-wrap: wrap;
      }

      .td-content {
        display: flex;
        justify-content: space-between;
      }

      .table-header-container {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
      }
      .two-line-ellipsis {
        display: -webkit-box;
        -webkit-line-clamp: 2; /* Limit to two lines */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal; /* Override to allow wrapping */
      }

      .material-search-btn {
        display: inline-block;
      }
    `,
  ],
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    TooltipModule,
    InputTextModule,
    MultiSelectModule,
    FormsModule,
    TooltipModule,
  ],
})
export class RecommendedPricesQuotesTableComponent {
  constructor(private router: Router) {}
  public data: any = {}
  loading: boolean = true

  cols: any[] = [
    { field: 'QUOTE', header: 'Quote', align: 'default' },
    { field: 'QUOTELINE', header: 'Quote Line', align: 'default' },
    { field: 'PART_NAME__C', header: 'Part Name', align: 'default' },
    { field: 'ACCOUNT_NAME__C', header: 'Customer Name', align: 'default' },
    { field: 'SBQQ__NUMBER__C', header: 'Line Number', align: 'right' },
    {
      field: 'ORIGINAL_REC_PRICE',
      header: 'Original Rec. Price',
      align: 'right',
    },
    { field: 'ORIGINAL_REC_PRICE_CUR', header: 'Currency', align: 'default' },
    {
      field: 'ORIGINAL_TA_PRICE__C',
      header: 'Original TA Price',
      align: 'right',
    },
    {
      field: 'ORIGINAL_CURRENCY_ISO_CODE__C',
      header: 'Orig. Currency ISO Code',
      align: 'default',
    },
    { field: 'TA_PRICE__C', header: 'TA Price', align: 'right' },
    { field: 'TA_PRICE_CUR', header: 'TA Price Currency', align: 'default' },

    { field: 'SBQQ__QUANTITY__C', header: 'Quantity', align: 'right' },
    { field: 'UOM__C', header: 'Unit of Measure', align: 'default' },
    { field: 'INCOTERMS__C', header: 'Incoterms', align: 'default' },
    { field: 'SBQQ__DESCRIPTION__C', header: 'Description', align: 'default' },
    {
      field: 'NET_UNIT_PRICE_EURO__C',
      header: 'Net Unit Price (EURO)',
      align: 'right',
    },
    { field: 'SBQQ__NETPRICE__C', header: 'Net Price', align: 'right' },
    { field: 'NET_PRICE_CUR', header: 'Net Price Currency', align: 'default' },
    { field: 'NETPR', header: 'Last Sold Price', align: 'right' },
    { field: 'WAERK', header: 'Last Price Currency', align: 'default' },
    { field: 'LAST_QUOTE_NAME', header: 'LAST QUOTE NAME', align: 'default' },
    { field: 'LAST_QUOTE_PRICE', header: 'LAST QUOTE PRICE', align: 'default' },
    { field: 'LAST_QUOTE_DATE', header: 'LAST QUOTE DATE', align: 'default' },
    {
      field: 'LAST_QUOTE_INCOTERMS',
      header: 'LAST QUOTE INCOTERMS',
      align: 'default',
    },
    {
      field: 'REC_PRICE_CAPPED',
      header: 'AI Recommendation Price(local currency)',
      align: 'right',
    },
    {
      field: 'REC_PRICE_EXPLANATION',
      header: 'AI Price Explanation',
      align: 'default',
    },
    {
      field: 'REC_PRICE_CAPPED_PERCENT',
      header: 'AI Rec. Price %',
      align: 'right',
    },
  ]

  goToRecommendendPrices(material: string) {
    this.router.navigate(['/pricing-history'], {
      queryParams: { materialId: material },
    })
  }

  selectedColumns = this.cols

  @Input() quoteId: string | undefined

  @Input()
  set tableData(data: any) {
    this.data = data
  }

  exportCsv(dt: any) {
    const original = this.data
    try {
      const rows = Array.isArray(this.data) ? this.data : []
      const formatted = rows.map((row: any) => {
        const copy: any = {}
        Object.keys(row || {}).forEach((k) => {
          const v = row[k]
          if (v == null) {
            copy[k] = v
            return
          }
          if (v instanceof Date || this.isIsoDateString(v)) {
            copy[k] = this.formatDate(v)
          } else {
            copy[k] = v
          }
        })
        return copy
      })

      dt.value = formatted
      dt.exportCSV()
    } finally {
      dt.value = original
    }
  }

  private isIsoDateString(val: any): boolean {
    return typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(val)
  }

  private formatDate(val: any): string {
    const d = val instanceof Date ? val : new Date(val)
    if (isNaN(d.getTime())) return String(val)
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    return `${dd}-${mm}-${yyyy}`
  }
}
